<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements";

  interface Props extends HTMLAttributes<SVGSVGElement> {
    size?: number;
  }

  let { size = 24, ...rest }: Props = $props();

  const uid = $props.id();
</script>

<svg
  aria-label="poolside logo"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <mask
    id="uid"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="24"
    height="24"
  >
    <rect width="24" height="24" fill="url(#paint0_linear_277_30011)" />
    <rect width="24" height="24" fill="url(#paint1_linear_277_30011)" />
    <rect width="24" height="24" fill="url(#paint2_linear_277_30011)" />
  </mask>
  <g mask="url(#{uid})">
    <path
      d="M6.74232 22.7861C4.51533 21.6997 2.70639 19.9835 1.5095 17.8233C0.340262 15.7124 -0.164894 13.3312 0.0472178 10.937C0.095241 10.4005 0.567912 10.0044 1.10467 10.0518C1.64042 10.0995 2.03716 10.5726 1.98982 11.1095C1.81209 13.1149 2.23596 15.11 3.21568 16.8789C4.05914 18.402 5.26725 19.6615 6.74182 20.5644L11.3282 11.1588C9.53298 10.5609 8.03771 10.8212 7.90314 10.8473C7.8834 10.8519 7.86431 10.8551 7.8449 10.859C7.39789 10.9338 6.96551 10.6895 6.79145 10.2833C6.55124 9.83482 5.83005 8.73861 4.95719 8.31279C4.08432 7.88696 2.7391 8.02432 2.30603 8.11848C1.94091 8.19822 1.56091 8.06208 1.33028 7.76848C1.09965 7.47488 1.05545 7.07445 1.21915 6.73872C4.11748 0.791471 11.3152 -1.68723 17.2615 1.21362C23.2078 4.11448 25.6839 11.3067 22.7906 17.2522C22.7877 17.2583 22.7847 17.2644 22.7814 17.2711C19.878 23.2117 12.6859 25.6857 6.74232 22.7861ZM13.08 12.0134L8.49395 21.4184C13.1226 23.1474 18.3897 21.2264 20.7982 16.8602C20.4597 16.3362 19.8657 15.585 19.1781 15.2496C18.2898 14.8162 16.9882 14.9581 16.541 15.0521C16.4674 15.0696 16.3941 15.078 16.3203 15.0788C16.1882 15.0794 16.0541 15.0532 15.9254 14.9971C15.792 14.9387 15.6714 14.8507 15.574 14.7372C15.5184 14.6717 15.4724 14.6 15.4354 14.5236C15.4067 14.4662 14.6954 13.0861 13.0793 12.0131L13.08 12.0134ZM5.81052 6.55936C6.55735 6.9237 7.1661 7.50274 7.62059 8.04908C9.02608 5.89909 10.9335 4.27517 12.4069 3.22815C12.9544 2.83934 13.5213 2.47584 14.0673 2.16218C10.2322 1.35692 6.21281 2.87683 3.8823 6.07684C4.49916 6.11907 5.17996 6.25091 5.81153 6.55902L5.81052 6.55936ZM18.4811 4.3163C18.5701 4.93971 18.6331 5.60966 18.6636 6.28127C18.7457 8.08218 18.6416 10.5766 17.8191 13.0027C18.5051 13.0211 19.3029 13.1424 20.0328 13.4985C20.6846 13.8165 21.231 14.2975 21.6611 14.7777C22.759 10.9638 21.4831 6.84896 18.4808 4.31698L18.4811 4.3163ZM13.0867 9.77521C14.4354 10.4332 15.4103 11.3085 16.0711 12.0632C17.1461 8.57024 16.6775 4.66145 16.2862 3.2138C14.9048 3.79666 11.5361 5.83346 9.4468 8.8315C10.4492 8.88739 11.7387 9.11757 13.0867 9.77521Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_277_30011"
      x1="6.75"
      y1="20.55"
      x2="5.625"
      y2="20.55"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop offset="1" stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_277_30011"
      x1="6.825"
      y1="11.85"
      x2="7.2"
      y2="11.1375"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-opacity="0" />
      <stop offset="1" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_277_30011"
      x1="0.975"
      y1="20.5125"
      x2="0.975"
      y2="10.9125"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop offset="0.105" stop-opacity="0.9" />
      <stop offset="0.903766" stop-opacity="0.04" />
      <stop offset="1" stop-opacity="0" />
    </linearGradient>
  </defs>
</svg>
